import {h, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import CashoutService from "../../../services/cashout";

import * as C from "../desktop-templates/cashout.jsx";


export default class CashoutComponent extends Component {
	render() {
		return <C.CashoutContents>
			{false && <C.CashoutFiltersRow>
				<C.CashoutFilter>
					<C.CashoutFilterButton active={true}><Trans>All</Trans></C.CashoutFilterButton>
					<C.CashoutFilterButton><Trans>Live</Trans></C.CashoutFilterButton>
					<C.CashoutFilterButton><Trans>Prematch</Trans></C.CashoutFilterButton>
				</C.CashoutFilter>
			</C.CashoutFiltersRow>}
			<OpenTicketsList />
		</C.CashoutContents>
	}
}

export class OpenTicketsList extends Component {
	state = {
		bets: null
	}
	componentWillMount() {
		this.loadBets()
		this.handler = setInterval(() => {
			if (this.state.bets == null)
				return;
			const liveTickets = this.state.bets.filter(t => t.live);
			if (liveTickets)
				CashoutService.fetchCurrentOddsForLiveTickets(liveTickets).then(r => this.setState({}))

			const prematchTickets = this.state.bets.filter(t => !t.live);
			if (prematchTickets)
				CashoutService.fetchCurrentOddsForPrematchTickets(prematchTickets).then(r => this.setState({}))
		}, 3e3)
	}
	componentWillUnmount() {
		clearInterval(this.handler)
	}
	loadBets() {
		CashoutService.fetchOpenBets().then(bets => {
			this.setState({bets: bets})
		})
	}
	render() {
		return <div class="w-full bg-slate-800 rounded-lg overflow-hidden">
			<div class="hidden w-full bg-slate-900 p-2 uppercase text-slate-100"><span>Cashout</span></div>
			<C.CashoutTicketsContainer>
			{this.state.bets && this.state.bets.length > 0
				? this.state.bets.map(ticket => <Ticket ticket={ticket} onCashout={e => this.loadBets()} />)
				: <C.CashoutEmptyStatus />}
		</C.CashoutTicketsContainer></div>
	}
}

export class Ticket extends Component {
	cashoutTicket(ticket, expectedWin) {
		if (!window.confirm("Do you want to cashout this ticket?"))
			return;
		CashoutService.doCashout(ticket, expectedWin).then((cashoutResult) => {
			this.setState({})
			this.props.onCashout()
			alert("Cashout successful")
		})
	}
	renderOutcome(outcome) {
        const currentOdds = CashoutService.getUpdatedOdd(outcome.id);
		const showLiveOdds = outcome.date <= Date.now();

		return <C.TicketSelection>
			<C.TicketEvent>{outcome.name}</C.TicketEvent>
			<C.TicketDate>{new Date(outcome.date).toLocaleString()}</C.TicketDate>
			<C.TicketOutcome>
				<C.TicketOutcomeDescription>{outcome.market} - {outcome.outcome}</C.TicketOutcomeDescription>
				{!showLiveOdds
					? null
					: <C.TicketOutcomeLiveOdd>{currentOdds ? outcome.value : '-'}</C.TicketOutcomeLiveOdd>}
				<C.TicketOutcomeOdd>{outcome.value}</C.TicketOutcomeOdd>
				<C.TicketOutcomeStatusIcon>{outcome.status}</C.TicketOutcomeStatusIcon>
			</C.TicketOutcome>
		</C.TicketSelection>
    }
	renderCashoutButton(ticket) {
		const cashoutWinAmount = CashoutService.calculateCashoutWin(ticket);

		return <div
				   class="px-2 py-1 rounded bg-kobaaccent-500 text-black font-bold text-xs text-center cursor-pointer"
				   onClick={e => this.cashoutTicket(ticket, cashoutWinAmount)}>
			<div class="uppercase"><Trans>Cashout</Trans></div>
			<div class="text-sm">{cashoutWinAmount.toFixed(2)} {ticket.currency}</div>
		</div>
	}
	render({ticket}) {
		return <C.Ticket>
			<C.TicketHeader>
				<C.TicketType>{ticket.live ? <Trans>Live</Trans> : <Trans>Prematch</Trans>}</C.TicketType>
				<C.TicketPrintBtn onClick={e => Page.printTicket(ticket)}>P</C.TicketPrintBtn>
			</C.TicketHeader>
			<C.TicketSelections>
				{ticket.odds.map(outcome => this.renderOutcome(outcome))}
			</C.TicketSelections>
			<C.TicketPriceInfo>
				<C.TicketPrice>
					<C.TicketPriceLabel><Trans>Stake</Trans>:</C.TicketPriceLabel>
					<C.TicketPriceValue>{ticket.betAmount}</C.TicketPriceValue>
				</C.TicketPrice>
				<C.TicketMaxWin>
					<C.TicketPriceLabel><Trans>Total Win</Trans></C.TicketPriceLabel>
					<C.TicketPriceValue>{ticket.maxWinAmount}</C.TicketPriceValue>
				</C.TicketMaxWin>
				{this.renderCashoutButton(ticket)}
			</C.TicketPriceInfo>
		</C.Ticket>
	}
}